import React, { useContext } from "react";
import { QuestionsContextMemorySpace } from "../../../../contexts/questions/questionsContext";
import { Link } from "react-router-dom";
import "./grupo-menu.scss";

export const GrupoMenuComponent = () => {
  const { question } = useContext(QuestionsContextMemorySpace);

  const filteredQuestions = question.filter((item) => !item.eliminado);

  // const limitedQuestions =
  //   filteredQuestions.length >= 8 ? filteredQuestions.slice(0, 8) : filteredQuestions.length > 4 ? filteredQuestions.slice(0, 4) : filteredQuestions;

  const limitedQuestions=filteredQuestions.slice(0,filteredQuestions.length-filteredQuestions.length%4)

  const partitionArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const partitionedQuestions = partitionArray(limitedQuestions, 4);

  return (
  <div className="grupo-menu-container">
    <div className="busqueda ayudaHB-pc">
      <span>Búsquedas más frecuentes</span>
    </div>
    <div className="grupo-menu-grid">
      {limitedQuestions.map((item) => (
        <div key={item.id} className="grupo-menu-card-wrapper">
          {item.slug && (
            <Link to={`/micrositio/${item.slug}`}>
              <div className="grupoMenuItemMicro">
                  {item.icono && (
                    <img
                      src={item.icono.url}
                      className="grupoMenuIconoMicrositio"
                      alt={item.titulo}
                    />
                  )}
                <div className="grupoMenuTextoMicrositio">{item.titulo}</div>
              </div>
            </Link>
          )}
        </div>
      ))}
    </div>
  </div>
);

};
